module.exports = __webpack_public_path__ + "img/ic_not_quote_price.c422a07e.svg";